import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import DashboardSectionHeader from 'layouts/Dashboard/DashboardSectionHeader';
import { HeaderSectionIcon } from 'components';

const ReportsHeader = ({ title, description }) => {
  return (
    <DashboardSectionHeader>
      <header
        className='header flex flex-colgap-8'
        style={{
          borderBottom: 'none',
          paddingBottom: 0,
        }}
      >
        <HeaderSectionIcon />

        <div>
          <h1 className='h1 main_section_header_title'>{title}</h1>
          <p className='description main_section_header_desc'>{description}</p>
        </div>
      </header>
    </DashboardSectionHeader>
  );
};

ReportsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ReportsHeader;
